import { Component, OnInit } from '@angular/core';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { UserCommonService } from 'app/modules/shared/services/user-common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractControl, FormBuilder, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { UiService } from 'app/modules/shared/services/ui.service';
import { ErrorBindingService } from 'app/modules/shared/services/error-binding.service';
import { AppSettings } from 'app/modules/shared/app.settings';
import { Message } from 'primeng/api';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  supportData: any;
  tokenId;
  locationDetails: any = null;
  setPasswordForm: UntypedFormGroup;
  inputType = 'password';
  cnfInputType = 'password';
  signInDescription;
  errorMessage: Message[] = [];
  otpId;
  passwordError = [{
    message: false
  }];
  changePasswordErrors = [
    {
      newPassword: false,
      newConfirmPassword: false,
    }
  ];
  passwordType = 'password';
  logoPath = AppSettings.logoPath;
  
  constructor(
    private commonBindingDataService: CommonBindingDataService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private userCommonService: UserCommonService,
    private uiService: UiService,
    private commonService: CommonBindingDataService,
    private router: Router,
    private errorBindingService: ErrorBindingService,

  ) { }

  ngOnInit() {
    this.userCommonService.clearAuthenticatedSession();
    this.signInDescription = this.commonBindingDataService.getLabel('label_sign_in_description');
    this.tokenId = this.route.snapshot.params.token;
    this.setPasswordForm = this.formBuilder.group({
      newPassword: ['', [Validators.required, Validators.minLength(8),
      Validators.pattern(AppSettings.PASSWORD_VALIDATIONS)]],
      newConfirmPassword: ['', [Validators.required, Validators.minLength(8),
      Validators.pattern(AppSettings.PASSWORD_VALIDATIONS), this.passwordMatchValidator()]]
    });

    this.subscribePasswordMatchValidation();
  }

  private subscribePasswordMatchValidation(): void {
    const confirmControl = this.setPasswordForm.get('newConfirmPassword');
    const revalidateConfirmPassword = () => {
      confirmControl?.updateValueAndValidity({ emitEvent: false });
    };

    this.setPasswordForm.get('newPassword')?.valueChanges.subscribe(revalidateConfirmPassword);
    this.setPasswordForm.get('newConfirmPassword')?.valueChanges.subscribe(revalidateConfirmPassword);
  }

  showPasswordMismatchError(): boolean {
    const newPasswordControl = this.setPasswordForm?.get('newPassword');
    const confirmPasswordControl = this.setPasswordForm?.get('newConfirmPassword');

    if (!newPasswordControl || !confirmPasswordControl) {
      return false;
    }

    const newPassword = newPasswordControl.value;
    const confirmPassword = confirmPasswordControl.value;
    const fieldsTouched = newPasswordControl.dirty || newPasswordControl.touched
      || confirmPasswordControl.dirty || confirmPasswordControl.touched;

    return fieldsTouched && !!newPassword && !!confirmPassword && newPassword !== confirmPassword;
  }

    private passwordMatchValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.parent || !control.value) {
        return null;
      }

      const newPassword = control.parent.get('newPassword')?.value;
      return newPassword === control.value ? null : { passwordMismatch: true };
    };
  }

  passwordNotMatched() {
    if (this.setPasswordForm.controls.newPassword.value !== this.setPasswordForm.controls.newConfirmPassword.value) {
      const error = {
        general: [
          {
            message: this.commonService.getLabel('error_new_confirm_password_not_match')
          }
        ]
      };
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
      this.errorBindingService.onAPIValidationError(error, this.changePasswordErrors);
    } else {
      return true;
    }
  }

  requestData() {
    return {
      tokenType: 'RESET_PASSWORD',
      token: this.tokenId,
      password: this.setPasswordForm.controls.newPassword.value,
    };
  }

  doChangePassword() {
    const passwordVerified = this.passwordNotMatched();
    if (passwordVerified) {
      const data = this.requestData();
      this.userCommonService.resetPassword(data).subscribe(results => {
        const successMessage = this.getResetPasswordSuccessMessage(results);
        this.uiService.showMessage(successMessage, AppSettings.MESSAGE_TYPE.SUCCESS);
        this.setPasswordForm.reset();
        setTimeout(() => {
          this.router.navigate(['/signin']);
        }, 1000);
      }, (error) => {
        const errorMessage = error?.general?.[0]?.message
          || this.commonService.getLabel('msg_error_summary');
        this.uiService.showMessage(errorMessage, AppSettings.MESSAGE_TYPE.ERROR);
      });
    }
  }

  private getResetPasswordSuccessMessage(results: any): string {
    const apiMessage = results?.general?.find((item: any) => item?.message)?.message;
    return apiMessage || 'Password has been reset successfully.';
  }

  onCancel() {
    this.setPasswordForm.reset();
  }

}
